import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { OrderReviewContext } from './OrderReviewContext';
import DisplayObject from './DisplayObject';

const propTypes = {
  classes: PropTypes.object.isRequired,
  isCancelled: PropTypes.bool,
};

function HazardHubData({ classes }) {
  const {
    state: { hazardHubData },
  } = useContext(OrderReviewContext);

  return (
    <Grid item xs={12} className={classes.container}>
      <Card className="border-left-green">
        <CardHeader
          className={classes.cardHeader}
          titleTypographyProps={{ className: classes.cardHeaderTitle }}
          title="HazardHub Data"
        />
        <CardContent className={classes.cardContent}>
          <DisplayObject object={hazardHubData} />
        </CardContent>
      </Card>
    </Grid>
  );
}

const styles = theme => ({
  container: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: 1,
    flex: 1,
  },
  cardContent: {
    padding: '0 !important',
  },
  cardHeader: {
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
    textAlign: 'left',
    color: 'var(--jmi-blue)',
  },
});

HazardHubData.propTypes = propTypes;
export default withStyles(styles)(withRouter(HazardHubData));
